// extracted by mini-css-extract-plugin
module.exports = {"root":"az_e9b","expanded":"az_f9b"};